@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Tax Access Sync Log Details"
                  cancelHelpContentId="app.cancel"
                  cancelClass="btn-primary"
                  [hideSave]="true"
                  (cancel)="cancel()">
    @if (taxAccessSyncDiagnosticsDetail) {
        <div class="ws-flex-container-vertical ws-stretch">
            <div class="detail-fields-row">
                <div class="detail-field detail-field--wide">
                    <label>Batch ID:</label>
                    <span>{{ taxAccessSyncDiagnosticsDetail.batchId }}</span>
                </div>
                <div class="detail-field">
                    <label>Run Type:</label>
                    <span>{{ runTypeLabels[taxAccessSyncDiagnosticsDetail.runType] }}</span>
                </div>
                <div class="detail-field">
                    <label>Run Status:</label>
                    <span>{{ runStatusLabels[taxAccessSyncDiagnosticsDetail.runStatus] }}</span>
                </div>
            </div>
            <div class="detail-fields-row">
                <div class="detail-field">
                    <label>Processed:</label>
                    <span>{{ taxAccessSyncDiagnosticsDetail.processedCount }}</span>
                </div>
                <div class="detail-field">
                    <label>Sent:</label>
                    <span>{{ taxAccessSyncDiagnosticsDetail.sentCount }}</span>
                </div>
                <div class="detail-field">
                    <label>Skipped:</label>
                    <span>{{ taxAccessSyncDiagnosticsDetail.skippedCount }}</span>
                </div>
                <div class="detail-field">
                    <label>Failed:</label>
                    <span>{{ taxAccessSyncDiagnosticsDetail.failedCount }}</span>
                </div>
                <div class="detail-field">
                    <label>Unmapped:</label>
                    <span>{{ taxAccessSyncDiagnosticsDetail.unmappedCount }}</span>
                </div>
            </div>
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label style="margin-top: 16px">Logs:</label>
                <tax-access-sync-log-details-grid
                    [summaryLogId]="taxAccessSyncDiagnosticsDetail.taxAccessSyncSummaryLogId">
                </tax-access-sync-log-details-grid>
            </div>
        </div>
    }
</ws-modal-wrapper>
